import {Link} from "preact-router/match";
import {h} from "preact";
import {useAppContext} from "../../../../contexts";

const LowerRow = () => {
    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div
            className={`bg-light-gray font-museo container-fluid flex flex-col text-black dark:text-white ${highContrast ? "grayBackground" : ""}`}>
            <div className="px-4 xmd:sabin-container w-full xmd:flex xmd:gap-4 xmd:items-center justify-center !my-5">
                <div className="!text-[16px] flex flex-col items-center justify-center gap-y-1">
                    <p
                        className={"text-center"}
                        data-testid="footer-cnpj-label"
                    >
                        Sabin Medicina Diagnóstica - CNPJ - 00.718.528/0001-09
                    </p>
                    <div className="text-center xmd:text-left">
                        <Link
                            href="/termos-de-uso"
                            className="mr-3 underline underline-offset-2"
                            data-testid="footer-base-questions-link"
                        >
                            <span data-testid="footer-base-questions-label">
                                Termos de Consentimento
                            </span>
                        </Link>
                        <Link
                            href="/politica-de-privacidade"
                            className="mr-3 underline underline-offset-2"
                            data-testid="footer-policy-link"
                        >
                            <span data-testid="footer-policy-label">
                                Política de Privacidade
                            </span>
                        </Link>
                        <Link
                            href="/mapa-do-site"
                            className="underline underline-offset-2"
                            data-testid="footer-map-link"
                        >
                            <span data-testid="footer-map-label">
                                Mapa do Site
                            </span>
                        </Link>
                    </div>
                    <p className={"hidden text-white leading-none text-[10px] mt-2 ml-3"}>
                        build v08.04-15:08
                    </p>
                </div>
            </div>
        </div>
    )
}

export default LowerRow;
